const nomesBonitosCategoria = {
  melhorfilme: "Melhor Filme",
  melhordirecao: "Melhor Direção",
  melhorator: "Melhor Ator",
  melhoratriz: "Melhor Atriz",
  melhoratorcoadjuvante: "Melhor Ator Coadjuvante",
  melhoratrizcoadjuvante: "Melhor Atriz Coadjuvante",
  melhorescalacaodeelenco: "Melhor Escalação de Elenco",
  melhorroteirooriginal: "Melhor Roteiro Original",
  melhorroteiroadaptado: "Melhor Roteiro Adaptado",
  melhorfilmeinternacional: "Melhor Filme Internacional",
  melhoranimacao: "Melhor Animação",
  melhordocumentario: "Melhor Documentário",
  melhoredicao: "Melhor Edição",
  melhorfotografia: "Melhor Fotografia",
  melhorfigurino: "Melhor Figurino",
  melhordirecaodearte: "Melhor Direção de Arte",
  melhormaquiagem: "Melhor Maquiagem",
  melhorefeitosvisuais: "Melhor Efeitos Visuais",
  melhortrilhasonora: "Melhor Trilha Sonora",
  melhorcancaooriginal: "Melhor Canção Original",
  melhorsom: "Melhor Som",
  melhorcurtametragem: "Melhor Curta-Metragem",
  melhoranimacaoemcurtametragem: "Melhor Animação em Curta-Metragem",
  melhordocumentarioemcurtametragem: "Melhor Documentário em Curta-Metragem",
  melhorduble: "Melhor Coordenação de Dublê",
  melhorfilmeemdrama: "Melhor Filme em Drama",
  melhorfilmeemcomedia: "Melhor Filme em Comédia ou Musical",
  melhorfilmeblockbuster: "Melhor Filme Blockbuster",
  melhoratoremdrama: "Melhor Ator em Drama",
  melhoratrizemdrama: "Melhor Atriz em Drama",
  melhoratoremcomediaoumusical: "Melhor Ator em Comédia ou Musical",
  melhoratrizemcomediaoumusical: "Melhor Atriz em Comédia ou Musical",
  melhorroteiro: "Melhor Roteiro",
  melhorfilmeemlinguanaoinglesa: "Melhor Filme em Língua Não Inglesa",
  melhorelenco: "Melhor Elenco",
  melhoratricoadjuvante: "Melhor Atriz Coadjuvante", // erro de digitação original mantido corrigido no nome bonito
  melhorequipededuble: "Melhor Equipe de Dublês",
  melhorjovematoratriz: "Melhor Jovem Ator/Atriz",
  melhorcomedia: "Melhor Comédia",
  melhorcancao: "Melhor Canção",
  melhordocumetario: "Melhor Documentário", // erro de digitação original mantido corrigido no nome bonito
  melhorfilmebritanico: "Melhor Filme Britânico",
  melhorfilmefamiliar: "Melhor Filme Familiar",
  melhoraorcoadjuvante: "Melhor Ator Coadjuvante", // erro original mantido, nome bonito certo
  melhoratoratrizemascensao: "Melhor Ator/Atriz em Ascensão",
  melhorescalacao: "Melhor Escalação",
  melhorestreiadeumdiretorescritorouprodutorbritanico: "Melhor Estreia de um Diretor, Escritor ou Produtor Britânico",
  melhorcurtabritanico: "Melhor Curta Britânico",
  melhorcurtadeanimacaobritanico: "Melhor Curta de Animação Britânico"
};

export default nomesBonitosCategoria;